import { useRef, useState } from 'react';

export function usePushHistory<T>(initialValues: T[]) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [values, setValues] = useState<T[]>(initialValues);

    const initialValuesRef = useRef(initialValues);

    const hasNext = currentIndex < values.length - 1;
    const hasPrev = currentIndex > 0;

    const init = (values?: T[]) => {
        const newValues = values || initialValuesRef.current;
        setValues(newValues);
        setCurrentIndex(0);
    };

    const push = (range: T) => {
        setValues([...values.slice(0, currentIndex + 1), range]);
        setCurrentIndex(currentIndex + 1);
    };

    const goBack = () => {
        setCurrentIndex(Math.max(currentIndex - 1, 0));
    };

    const goForward = () => {
        setCurrentIndex(Math.min(currentIndex + 1, values.length - 1));
    };

    return {
        values,
        currentValue: values[currentIndex],
        init,
        push,
        goBack,
        goForward,
        hasNext,
        hasPrev,
    };
}
